import Vue from '@/main.js'
let webScoket = null;
let messageCallback = {};
let wsUrl = `wss://iop.cozy-time.com//iop/webSocket/`

function onOpen (e) {
  console.log("WebSocket 连接成功")
}

function onMessage (e) {
  try {
    if (messageCallback == {}) {
      return
    }
    for (let key in messageCallback) {
      messageCallback[key](JSON.parse(e.data))
    }
  } catch (exception) {
    console.log('onMessage error:' + exception)
  }
}

function onError (e) {
  console.log("连接错误:" + e)
}

function onClose (e) {
  // e.code === 1000  表示正常关闭。 无论为何目的而创建, 该链接都已成功完成任务。
  // e.code !== 1000  表示非正常关闭。
  if (e && e.code !== 1000) {
    console.log("连接异常")
    // 连接异常中断 尝试重连
    setTimeout(() => {
      initWebSocket()
    }, 6000)
  } else {
    console.log("连接关闭")
  }
}

function initWebSocket () {
  if (typeof (WebSocket) == undefined) {
    return Vue.$message.error('您的浏览器不支持webSocket')
  }
  let userId = localStorage.getItem('partnerInfo') ? JSON.parse(localStorage.getItem('partnerInfo')).partnerCode : '0';
  const requstWsUrl = wsUrl + 'b2b-' + userId;
  webScoket = new WebSocket(requstWsUrl)

  // 建立连接
  webScoket.onopen = function (e) {
    onOpen(e)
  }

  // 收到消息
  webScoket.onmessage = function (e) {
    onMessage(e);
  }

  // 连接异常
  webScoket.onerror = function (e) {
    onError(e);
  }

  // 关闭连接
  webScoket.onclose = function (e) {
    onClose(e)
  }
}

// 向服务端发送消息
function webScoketSend () {
  setTimeout(() => {
    try {
      if (webScoket.readyState === webScoket.OPEN) {
        webScoket.send('ping')
      }
    } catch (e) {
      initWebSocket()
    }
  }, 500)
}

/**
 * 初始化webSocket
 * @param {Boolean} isConnect 是否需要建立连接
 * @param {Function} successCallback 接收到服务端消息后的回调
 * @param {String} successCallbackName 回调方法名称，向每一个模块发送消息
 */
export function sendWebSocket (isConnect, successCallback, successCallbackName) {
  if (isConnect) {
    // 连接socket
    initWebSocket()
  }
  webScoketSend()
  if (!messageCallback.hasOwnProperty(successCallbackName)) {
    messageCallback[successCallbackName] = successCallback
  }
}

/**
 *
 * @param {String} name 根据模块名称移除监听方法
 */
export function removeHandler (name) {
  if (messageCallback.hasOwnProperty(name)) {
    delete messageCallback[name]
  }
}

/**
 * 断开webSocket连接
 */
export function closeSocket () {
  if (webScoket) {
    webScoket.close();
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/webSocket.js